import React, {useEffect, useState} from "react";
import {
  Box,
  Button,
  Column,
  Columns,
  Control,
  Field,
  File,
  Input,
  Select,
  TextArea,
  Title,
} from "@allxsmith/bestax-bulma";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import {fixEmptyDepartment, fixEmptyDates} from "../../../utils";
import {createSetJobAction} from "../../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getDepartmentsData} from "../../../state/selectors";
import ImageDisplay from "./ImageDisplay";
import {triggerUpload, onFileChange} from "../../../utils";
import {useDepartmentsData} from "../../../hooks/useDepartmentsData";
import DepartmentSelector from "../../Settings/Departments/DepartmentSelector";
import LoadingSpinner from "../../Utils/Spinner";
import Nav from "../../Nav/Nav";
import {ToastContainer,  toast} from "react-toastify";


export default function DefectForm(props) {

  let [selectedVehicle, setSelectedVehicle] = React.useState();
  const [department, setDepartment] = useState({});
  const [fileList, setFileList] = useState();
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [typeahead, setTypeahead] = useState();
  const [defectText, setDefectText] = useState("");
  const [statusText, setStatusText] = useState("DRIVEABLE");
  const [locationText, setLocationText] = useState("");
  const [driverName, setDriverName] = useState("");
  const [driverPhone, setDriverPhone] = useState("");
  const [mileage, setMileage] = useState(0);
  const [uploadUrl, setUploadUrl] = useState("");

  let dataFresh = useSelector(getDataFresh);
  const dateFields = ["book_in_date", "workshop_date", "finish_date"];

  const dispatch = useDispatch();

  const departmentsLoaded = useDepartmentsData({}, dataFresh);
  const departments = useSelector(getDepartmentsData);

  const departmentObjects = departmentsLoaded ? departments.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : {};


  const handleSearch = query => {
    setLoading(true);
    let url = props.endpoint + `vehicles?search=${query}`;
    axios.get(url).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handleVehicleSelect = e => {
    setSelectedVehicle(e[0]);
  }

  const handleDepartmentSelect = e => {
    setDepartment(departmentObjects[e.target.value]);
  }

  const deleteImage = id => {
    const conf = {
          url: "/api/deleteinternalimage/"+id,
          method: "delete"
    };
    axios(conf);
  }

  const validator = (data) => {
    if(data.vehicle && data.department){
      return true;
    }
    else{
      toast.warning("Vehicle and Department are required fields", {position:  "top-right"});
      return false;
    }
  }

  const onSave = () => {
    let dataToSave = {
      vehicle: selectedVehicle,
      defect_description: defectText,
      defect_status: statusText,
      location_of_van: locationText,
      defect_driver_name: driverName,
      defect_driver_number: driverPhone,
      is_defect: true,
      expected_mileage: mileage,
      work_items: [],
      defect_department: department
    };
    dataToSave = fixEmptyDates(dataToSave, dateFields);
    dataToSave = fixEmptyDepartment(dataToSave);
    if(validator(dataToSave)) {
      const conf = {
        method: "post",
        data: dataToSave,
        url: "api/createdefect"
      };
      axios(conf).then((res) => {
        dispatch(createSetJobAction(res.data));
        if (res) {
          if (fileList) {
            triggerUpload(fileList, res.data.id, selectedVehicle, setFileList, deleteImage, dataFresh, dispatch, "job");
          }
          window.open("/editjob/" + res.data.id, "_self")
        }
      }).catch(err => {
        if (err.response.data) {
          toast.error(
              JSON.stringify(err.response.data),{position: "top-right"}
          );
        }
      });
    }
  }

  const onFileDelete = (e, index) => {
    let dataTransfer = new DataTransfer();
    for(let i=0; i<fileList.length;i++){
      if(i !== index){
        dataTransfer.items.add(fileList[i]);
      }
    }
    setFileList(dataTransfer.files);
  }
  if(!departmentsLoaded){
    return (
        <div>
          <Nav/>
          <LoadingSpinner/>
        </div>
    )
  }


  // TODO(bestax-migrate): `inputProps` — spread these onto bestax File directly
  return (
    <div>
      <Nav/>
      <Box>
        <Title>Defect</Title>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">Vehicle</label>
              <Control>
                <AsyncTypeahead
                  useCache={false}
                  data-testid="vehicle-search"
                  id="typeahead"
                  labelKey="registration"
                  minLength={2}
                  name={"registration"}
                  onSearch={handleSearch}
                  onChange={handleVehicleSelect}
                  placeholder={"Search Vehicle Registration"}
                  options={searchData}
                  ref={typeahead => setTypeahead(typeahead)}
                  className="typeahead"
                  isLoading={isLoading}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <label className="label">Registration</label>
            <Input
              value={selectedVehicle ? selectedVehicle.registration : ""}
              disabled={true}
              readOnly={true}
            />
          </Column>
          <Column>
            <label className="label">Make</label>
            <Input
              value={selectedVehicle ? selectedVehicle.make : ""}
              disabled={true}
              readOnly={true}
            />
          </Column>
          <Column>
            <label className="label">Model</label>
            <Input
              value={selectedVehicle ? selectedVehicle.model : ""}
              disabled={true}
              readOnly={true}
            />
          </Column>
          <Column>
            <DepartmentSelector
              disabled={false}
              blank={true}
              value={department}
              options={departments}
              editable={true}
              name={"defect_department"}
              label={"Department"}
              onChange={handleDepartmentSelect}
              inlineEdit={false}
            />
          </Column>
        </Columns>
        <br/>
        <Columns isMultiline>
          <Column>
            <Control>
              <label className="label">Description of problem</label>
              <TextArea
                minLength={10}
                onChange={(e) => {
                  setDefectText(e.target.value)
                }}
                value={defectText}
              />
            </Control>
          </Column>
          <Column>
            <Control>
              <label className="label">Status of Vehicle</label>
              <Select
                onChange={(e) => {
                  setStatusText(e.target.value)
                }}
              >
                <option key={"DRIVEABLE"} value={"DRIVEABLE"}>DRIVEABLE</option>
                <option key={"NOT_DRIVEABLE"} value={"NOT_DRIVEABLE"}>NOT DRIVEABLE</option>
              </Select>
            </Control>
          </Column>
          <Column>
            <Control>
              <label className="label">Mileage of Vehicle</label>
              <Input
                type={"number"}
                value={mileage}
                onChange={(e) => {
                  setMileage(e.target.value)
                }}
              />
            </Control>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Control>
              <label className="label">Location of Van</label>
              <Input
                type={"text"}
                value={locationText}
                onChange={(e) => {
                  setLocationText(e.target.value)
                }}
              />
            </Control>
          </Column>
          <Column>
            <Control>
              <label className="label">Driver Name</label>
              <Input
                type={"text"}
                value={driverName}
                onChange={(e) => {
                  setDriverName(e.target.value)
                }}
              />
            </Control>
          </Column>
          <Column>
            <Control>
              <label className="label">Driver Phone Number</label>
              <Input
                type={"text"}
                value={driverPhone}
                onChange={(e) => {
                  setDriverPhone(e.target.value)
                }}
              />
            </Control>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Control>
              <File id={'defect-files'} data-testid={"defect-file-upload"} value={fileList} onChange={(e) => onFileChange(e, fileList, setFileList)} inputProps={{multiple: true}}></File>
            </Control>
          </Column>
        </Columns>
        { fileList &&
          <ImageDisplay
            dataFresh={dataFresh}
            fileList={fileList}
            onImageDelete={onFileDelete}
          />
        }
      </Box>
      <Box>
        <Control>
          <Button
            color={"success"}
            onClick={onSave}
            id={"defect-save"}
            data-testid={"defect-save-button"}
            isFullWidth
          >
            Create Defect
          </Button>
        </Control>
      </Box>
    </div>
  );


}